import { render, staticRenderFns } from "./IconCorrect.vue?vue&type=template&id=9a4a763e&"
import script from "./IconCorrect.vue?vue&type=script&lang=js&"
export * from "./IconCorrect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports